export default __webpack_public_path__ + "static/baudilio-bb9bbc4b2305b7fb6d2718db92e74c67.png";